<script lang="ts">
	import DescrizioneSito from "./DescrizioneSito.svelte";
	import Footer from "./Footer.svelte";
	import SideMenu from "./SideMenu.svelte";
	let pagina_scelta: number = 0;
	function cambia_pagina(n: number): void {
		pagina_scelta = n;
	}
</script>

<style>
</style>

<main>
	<SideMenu></SideMenu>
	<div class="container">
		<div class="row">
			<div class="col-sm">

			</div>
			
			
		</div>
		<div class="row">
			<div class="col-sm">
				<DescrizioneSito />
			</div>
			
		</div>
		<div class="row">
			<div class="col-sm">
				<Footer />
			</div>
			
		</div>
			
	</div>
</main>
